<template>
  <v-dialog :value="value" v-bind="props">
    <v-card style="overflow: hidden">
      <v-card-title row justify-center class="red white--text" style="font-size: 1.5em; font-weight: bold">
        エラー
      </v-card-title>
      <v-container align-start style="font-size: 1.25em">
        <slot name="content"></slot>
      </v-container>
      <v-layout row class="mt-1 mb-1">
        <v-flex align-self-center>
          <v-btn class="mb-1" color="primary" rounded raised @click="$emit('ok-button-click')">
            <v-icon left> mdi-check </v-icon>
            OK
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

const props = Vue.extend({
  props: {
    value: { default: false },
    props: {},
  },
});

@Component
export default class ErrorDialog extends props {}
</script>

